import {Directive} from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[isReferredAdult]',
  providers: [{provide: NG_VALIDATORS, useExisting: IsReferredAdultDirective, multi: true}]
})
export class IsReferredAdultDirective {

  constructor(private customValidator: CustomValidationService) {
  }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.isReferredAdultValidator()(control);
  }

}
